"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var falconyAnnouncements_1 = require("../../../../services/falconyAnnouncements");
var AnnouncementCard_1 = __importDefault(require("./components/AnnouncementCard"));
var SlideShow_1 = __importDefault(require("./components/SlideShow"));
var FalconyAnnouncementsWidget = function (_a) {
    var falconyAnnouncementsProps = _a.falconyAnnouncementsProps, widgetHeight = _a.widgetHeight, widgetWidth = _a.widgetWidth;
    var _b = (0, react_1.useState)([]), falconyAnnouncements = _b[0], setFalconyAnnouncements = _b[1];
    var url = falconyAnnouncementsProps.url, slideShowInterval = falconyAnnouncementsProps.slideShowInterval, visibleItemCount = falconyAnnouncementsProps.visibleItemCount, latestItemCount = falconyAnnouncementsProps.latestItemCount, _c = falconyAnnouncementsProps.refreshInterval, refreshInterval = _c === void 0 ? 1 : _c, oldestItemByMonth = falconyAnnouncementsProps.oldestItemByMonth, cardStyles = falconyAnnouncementsProps.cardStyles;
    var filteredFalconyAnnouncements = (0, react_1.useMemo)(function () {
        if (oldestItemByMonth) {
            var d = new Date();
            d.setMonth(d.getMonth() - oldestItemByMonth);
            d.setHours(0, 0, 0, 0);
            var sixMonthsInMilisecond_1 = d.getTime();
            return falconyAnnouncements
                .filter(function (item) { return item.createdAt >= sixMonthsInMilisecond_1; })
                .slice(0, latestItemCount);
        }
        return falconyAnnouncements.slice(0, latestItemCount);
    }, [falconyAnnouncements, latestItemCount, oldestItemByMonth]);
    (0, react_1.useEffect)(function () {
        if (url && refreshInterval) {
            var getAndSetData_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
                var falconyAnnouncementsData, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, (0, falconyAnnouncements_1.getFalconyAnnouncements)(url)];
                        case 1:
                            falconyAnnouncementsData = _a.sent();
                            setFalconyAnnouncements(falconyAnnouncementsData);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            // eslint-disable-next-line no-console
                            console.error(error_1);
                            setFalconyAnnouncements([]);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            getAndSetData_1();
            var refreshIntervalMilliSecond = refreshInterval * 60 * 1000;
            var refreshId_1 = setInterval(function () {
                getAndSetData_1();
            }, refreshIntervalMilliSecond);
            return function () { return clearInterval(refreshId_1); };
        }
    }, [url, refreshInterval]);
    if (filteredFalconyAnnouncements.length === 0) {
        return react_1.default.createElement(react_1.Fragment, null);
    }
    var latestFilteredFalconyAnnouncement = filteredFalconyAnnouncements[0], restFilteredFalconyAnnouncements = filteredFalconyAnnouncements.slice(1);
    var cardHeight = widgetHeight / (visibleItemCount + 1);
    var announcementsPageUrl = (0, falconyAnnouncements_1.getFalconyAnnouncementsPageUrl)(url);
    return (react_1.default.createElement(material_1.Grid, { container: true },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(SlideShow_1.default, { interval: slideShowInterval, groupSlideCount: 1, slides: (visibleItemCount === 1
                    ? filteredFalconyAnnouncements
                    : [latestFilteredFalconyAnnouncement]).map(function (item) { return (react_1.default.createElement(AnnouncementCard_1.default, { key: item.id, isLatest: true, announcementsPageUrl: announcementsPageUrl, announcement: item, widgetWidth: widgetWidth, cardHeight: 2 * cardHeight, cardStyles: cardStyles, showDescription: true })); }) })),
        restFilteredFalconyAnnouncements.length > 0 && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(SlideShow_1.default, { interval: slideShowInterval, groupSlideCount: visibleItemCount - 1, slides: restFilteredFalconyAnnouncements.map(function (item, i) { return (react_1.default.createElement(react_1.Fragment, { key: i },
                    react_1.default.createElement(AnnouncementCard_1.default, { cardStyles: cardStyles, key: item.id, announcement: item, widgetWidth: widgetWidth, cardHeight: cardHeight, showDescription: visibleItemCount <= 5 }))); }) })))));
};
exports.default = FalconyAnnouncementsWidget;
//# sourceMappingURL=FalconyAnnouncementsWidget.js.map